/* global _ */

import api from './api';

const { noop } = _;

var ENDPOINTS = {
	'login': 'innoway/v2/login',
	'register': 'innoway/v2/create_user',
	'recover': 'innoway/v2/send_temp_password',
	'oauth': 'innoway/v2/validate_token',
	'password': 'innoway/v2/update_password',
};

export default function( action, request, callback ) {
	var endpoint = ENDPOINTS[ action ];

	if ( ! endpoint ) {
		return;
	}

	callback = callback || noop;

	api( endpoint, request, response => {
		callback( response );
	}, 'POST' );
}
